<div class="flex items-center">
  <!-- Back Button -->
  @if (enableBackButton) {
  <button
    [attr.aria-label]="backButtonText"
    paxButton
    variant="basic"
    [attr.data-testid]="backButtonTestId"
    type="button"
    (click)="onBack()"
    iconLeft="arrow_left"
  >
    <span class="hidden sm:inline">{{ backButtonText }}</span>
  </button>
  }
</div>
